export const mediaContent = {
  nl: {
    seoTitle: 'Media · Rot8ion · Perpetual Plexus',
    seoDescription:
      'Pers en media over de lichtkunst van Rot8ion en het Perpetual Plexus netwerk: Eindhovens Dagblad, Omroep Brabant, De Telegraaf en meer.',
    title: 'Media',
    intro: undefined as string | undefined,
  },
  en: {
    seoTitle: 'Media · Rot8ion · Perpetual Plexus',
    seoDescription:
      'Press and media about the light art of Rot8ion and the Perpetual Plexus network: Eindhovens Dagblad, Omroep Brabant, De Telegraaf and more.',
    title: 'Media',
    intro: 'Press coverage is listed in its original language (mostly Dutch).',
  },
} as const;
